/**
 * Created by tomere on 16/04/2018.
 */
import BundleVersionDAO from '../../modules/distribution/components/bundle/version/DAO/BundleVersionDAO';
import DistributionBundlesDAO from '../../modules/distribution/DAO/bundles/DistributionBundlesDAO';
import {DISTRIBUTION_CONSTANTS} from '../../constants/distribution.constants';
import SERVICES_CONSTANTS from '../../constants/services.constants';
import BundleDeletionModel from '../../core/models/distribution/BundleDeletionModel';
import DistributionSiteModel from '../../core/models/distribution/DistributionSiteModel';

export default class DeleteBundleVersionService {

    constructor($rootScope, JFrogModal, JFrogEventBus, JFrogNotifications, distributionBundlesDAO, bundleVersionDAO, AppContext) {
        this.$rootScope = $rootScope;
        this.modal = JFrogModal;
        this.jFrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.jfrogNotifications = JFrogNotifications;
        this.distributionBundleResource = distributionBundlesDAO.Resource;
        this.bundleVersionDAO = bundleVersionDAO.Resource;
        this.DELETE_OPTIONS = DISTRIBUTION_CONSTANTS.BUNDLE_VERSION_DELETE_OPTIONS;
        this.AppContext = AppContext;
    }

    showSpinner() {
        window.store.dispatch('ENABLE_LOCAL_LOADER');
    }

    hideSpinner() {
        window.store.dispatch('DISABLE_LOCAL_LOADER');
    }

    /**
     *  launch the distribution modal
     */
    showVersionDeletionModal(daoParams, preselectedSites, onSuccessCb, isLocalDeletion) {
        this.daoParams = daoParams;
        this.modalScope = this.$rootScope.$new();
        this.modalScope.pairingStatus = this.AppContext.getDistributionPairingStatus();
        this.modalScope.formData = {
            dragDropHeaders: SERVICES_CONSTANTS.distributeBundleService.dragDropHeaders,
            bundle: daoParams.release_bundle,
            version: daoParams.release_bundle_version,
            columns: [{
                header: 'Name',
                field: 'name',
                width: '100%',
                filterable: true,
                cellTemplate: require('../sharedViewTemplate/distribution.site.cell.template.html')
            }],
            availableSites: [],
            selectedSites: [],
            isProcessingRequest: false
        };

        this.modalScope.closeModal = () => {
            return this.modalInstance.close();
        };

        this.modalScope.onSuccess = () => {
            if(this.modalScope && this.modalScope.closeModal) {
                this.modalScope.closeModal();
            }
            if(typeof onSuccessCb === 'function') {
                onSuccessCb();
            }
        };

        this.modalScope.isDistributionDisabled = this.isDistributionDisabled.bind(this);
        this.modalScope.isDndDisabled = this.isDndDisabled.bind(this);
        this.modalScope.header = 'Delete Release Bundle Version';
        this.modalScope.actionButtonText = 'Delete';
        this.modalScope.DELETE_OPTIONS = this.DELETE_OPTIONS;
        this.modalScope.formData.deleteDestination = this.DELETE_OPTIONS.DELETE_LOCALLY;
        this.modalScope.formData.onAfterDeleteAction = this.DELETE_OPTIONS.DO_NOTHING;
        this.modalScope.formData.showDeleteFormActions = true;
        this.modalScope.distributeToSelectedSites = this.distributeVersionDeleteToSelectedSites.bind(this);
        this.modalScope.self = this.modalScope;
        const selectedSites = isLocalDeletion ? null : preselectedSites;
        this.getSites(selectedSites);
        if (isLocalDeletion) {
            return this.distributeVersionDeleteToSelectedSites();
        }
        this.modalInstance = this.modal.launchModalWithTemplateMarkup(require('./delete.bundle.version.modal.template.html'), this.modalScope, 'lg');
    };

    getSites(preselectedSites) {
        this.showSpinner();
        this.distributionBundleResource.getSites({
            $no_spinner:true,
            action: DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.DELETE
        }).$promise.then((response) => {
            this.AppContext.setPairingStatus(true);
            this.setAvailableSites(response);
            this.setSelectedSites(selectedSites);
        }).finally(() => {
            this.hideSpinner();
        });
    }

    setAvailableSites(sites) {
        if (sites.length) {
            sites = _.map(sites, site => new DistributionSiteModel(site));
        }
        Array.prototype.splice.apply(this.modalScope.formData.availableSites, [this.modalScope.formData.availableSites.length, 0].concat(sites));
    }

    setSelectedSites(preselectedSites) {
        // Using a Map for keeping performance in O(n)
        let preSelectedSitesMap = new Map(_.map(preselectedSites, selectedSite => [ selectedSite.name, selectedSite]));
        let removed =_.remove(this.modalScope.formData.availableSites, availableSite => {
            return availableSite.license.valid_license && preSelectedSitesMap.has(availableSite.name);
        });
        Array.prototype.splice.apply(this.modalScope.formData.selectedSites, [this.modalScope.formData.selectedSites.length, 0].concat(removed));

        if(this.modalScope.formData.selectedSites && this.modalScope.formData.selectedSites.length) {
            this.modalScope.formData.deleteDestination = this.DELETE_OPTIONS.DELETE_GLOBALLY;
        }
    }

    distributeVersionDeleteToSelectedSites() {
        this.modal
                .confirm(`Delete version ${this.modalScope.formData.version} of release bundle ${this.modalScope.formData.bundle} ?`,
                        'Delete Release Bundle Version', {confirm: 'Delete'})
                .then(() => {
                    this.deleteVersion();
                });
    }

    distributeVersionDeleteToSites(sites, deleteDestination, daoParams, onSuccessAction = this.DELETE_OPTIONS.DO_NOTHING) {
        if (this.modalScope.isProcessingRequest) {
            return;
        }
        this.modalScope.isProcessingRequest = true;
        let payload = new BundleDeletionModel({
            sites: sites,
            on_success: onSuccessAction
        });

        let deferred;
        if(deleteDestination === this.DELETE_OPTIONS.DELETE_GLOBALLY) {
            deferred = this.bundleVersionDAO
                    .deleteReleaseBundleVersionGlobally(daoParams, payload.build()).$promise;
        } else if(deleteDestination === this.DELETE_OPTIONS.DELETE_LOCALLY) {
            deferred = this.bundleVersionDAO
                    .deleteReleaseBundleVersionLocally(daoParams).$promise;
        }
        deferred.then(() => {
            this.modalScope.onSuccess();
            this.jFrogEventBus.dispatch(this.EVENTS.VERSION_DELETED);
        });

    }

    deleteVersion() {
        this.distributeVersionDeleteToSites(
                this.modalScope.formData.selectedSites,
                this.modalScope.formData.deleteDestination,
                this.daoParams,
                this.modalScope.formData.onAfterDeleteAction
        );
    }

    isDistributionDisabled() {
        let scope = this.modalScope.formData;
        return (scope.deleteDestination === this.DELETE_OPTIONS.DELETE_GLOBALLY &&
                (!scope.selectedSites || !scope.selectedSites.length));
    }

    isDndDisabled() {
        let scope = this.modalScope.formData;
        return !scope.availableSites || (scope.deleteDestination === this.DELETE_OPTIONS.DELETE_LOCALLY);
    }
}

DeleteBundleVersionService.META = {
    name: 'DeleteBundleVersionService'
};

DeleteBundleVersionService.$inject = [
    '$rootScope',
    'JFrogModal',
    'JFrogEventBus',
    'JFrogNotifications',
    DistributionBundlesDAO.META.name,
    BundleVersionDAO.META.name,
    'AppContext'
];



// WEBPACK FOOTER //
// ./modules/distribution/services/deleteBundleVersion/delete.bundle.version.service.js